import styles from './course-cancellation.module.scss';
import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { Accordion, AccordionDetails, AccordionSummary, Froala, Icon, PrimaryButton, SecondaryButton, SnackBarContext, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@frontend-workspace/react-shared-lib';
import { IEmailTemplateSurvey } from '../../../_models/email-template-survey';
import { useTableData } from '../../table-data';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CourseCancellationProps { }

export function CourseCancellation(props: CourseCancellationProps) {
  const { data: emailTemplatesSurveys }: { data: IEmailTemplateSurvey } = useCourseGetRequestHook("settings/emailTemplates/courseDeregistration", []);

  const { rows } = useTableData();
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [emailTemplate, setEmailTemplate] = useState<string>(emailTemplatesSurveys?.emailTemplateHtml);

  useEffect(() => {
    if (emailTemplatesSurveys) {
      setEmailTemplate(emailTemplatesSurveys.emailTemplateHtml);
    }
  }, [emailTemplatesSurveys]);

  const handleResetEmailTemplate = () => {
    const emailTemplateCopy = emailTemplatesSurveys.emailTemplateHtml;
    setEmailTemplate(emailTemplateCopy);
  };

  const handleUpdateEmailTemplate = () => {
    const body = {
      id: emailTemplatesSurveys.id,
      name: emailTemplatesSurveys.name,
      emailTemplateHtml: emailTemplate
    }
    makeCourseRequest(`settings/emailTemplates/CourseDeregistration/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('tableData.updatedText'), type: "info", });
    }).catch(() => setSnackbarMessage({ content: t('tableData.couldNotUpdateText'), type: "error" }));
  };

  return (<>
    <Row>
      <Col xl={8}>
        <div className='mb-3'>
          <Accordion>
            <AccordionSummary
              expandIcon={<Icon>expand_more</Icon>}>
              <div className='d-flex align-items-center'>
                <Icon className='me-1' color='info'>info_outline</Icon>{t('tableData.explanationsOfVariousCodes')}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table sx={{ width: '100%' }} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t('standard.code')}</TableCell>
                      <TableCell>{t('standard.description')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, i) => (
                      <TableRow hover key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell>{row.code}</TableCell>
                        <TableCell>{row.description}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='mb-3'>
          <label className='mb-1'>{t('standard.cancelingCourse')}</label>
          <Froala
            maxHeight={800}
            model={emailTemplate || ''}
            onModelChanged={setEmailTemplate}
          />
        </div>
        <div>
          <PrimaryButton
            variant="contained"
            onClick={handleUpdateEmailTemplate}
            className='minButtonWidth me-3'>
            {t('standard.save')}
          </PrimaryButton>
          <SecondaryButton
            variant='outlined'
            onClick={handleResetEmailTemplate}
            className='minButtonWidth'>
            {t('standard.reset')}
          </SecondaryButton>
        </div>
      </Col>
    </Row>
  </>);
}

export default CourseCancellation;
